import { useMutation, useQueryCache } from 'react-query';
import { TournamentAPI } from 'api/admin/tournament';
import { TOURNAMENTS } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useCreateTournament() {
  const queryCache = useQueryCache();

  return useMutation(TournamentAPI.addTournament, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      dispatchToast({ message, type: 'success' });
      queryCache.invalidateQueries(TOURNAMENTS);
      onSuccess();
    },
  });
}
